import { render } from "./DialogSubBasin.vue?vue&type=template&id=0903c4b2&scoped=true"
import script from "./DialogSubBasin.vue?vue&type=script&lang=js"
export * from "./DialogSubBasin.vue?vue&type=script&lang=js"

import "./DialogSubBasin.vue?vue&type=style&index=0&id=0903c4b2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0903c4b2"]])

export default __exports__